import { setupWorker } from 'msw/browser'
import { handlers } from './handlers'

// Setup the service worker with our request handlers
export const worker = setupWorker(...handlers)

// Track whether the worker was started
let workerStarted = false

// Start the worker in development mode ONLY when not using real backend
export const startMocking = async () => {
    // Only start MSW if we're NOT using the real backend
    const useBackend = import.meta.env.VITE_USE_BACKEND === 'true'

    // Start MSW only when NOT using backend - feedback endpoints now exist on backend
    if (import.meta.env.DEV && !useBackend) {
        await worker.start({
            onUnhandledRequest: 'bypass', // Let non-mocked requests pass through to real backend
        })
        workerStarted = true
    } else if (useBackend && workerStarted) {
        // Only stop the worker if it was previously started
        try {
            await worker.stop()
            workerStarted = false

            // Also unregister any existing service workers for this origin
            if ('serviceWorker' in navigator) {
                const registrations = await navigator.serviceWorker.getRegistrations()
                for (const registration of registrations) {
                    if (registration.scope.includes('mockServiceWorker')) {
                        await registration.unregister()
                    }
                }
            }
        } catch (e) {
            // Worker wasn't running or couldn't be stopped, that's fine
        }
    }
}